import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../services/index';
import { message   } from 'antd';
import { Line } from 'react-chartjs-2';




class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			value: '',
			aToken: '',
			child_data: [],
			graph_data: [],
		}
		this.handleSizeChange = this.handleSizeChange.bind(this);
	}
	
	

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
			var date = new Date().toLocaleString("en-US", {timeZone: "Asia/Kolkata"});
			const new_acad = (new Date().getFullYear())+'-'+ (new Date().getFullYear()+1);
			
			var storedArray = JSON.parse(localStorage.getItem("schoolData"))
			var permission = storedArray['data'][0]['permission'];
			var user_type = storedArray['data'][0]['type'];
			setTimeout(() => {
				this.setState({ 
					user_id : storedArray['data'][0]['user_id'],
					permission : permission,
					user_type : user_type,
					academic_year : new_acad,
				});
			}, 50);
		}
		var user_id = storedArray['data'][0]['user_id'];
		var school_id = storedArray['data'][0]['school_id'];
		var type = storedArray['data'][0]['type'];
		var app = {user_id : user_id,school_id:school_id,type:type}
		getData('auth/get_login_token',app).then((result) => {
			let responseJson = result;
			if(responseJson.data){
				if(result['status'] == 200){
					var aToken= result['data'];
					localStorage.setItem("aToken",aToken);
					var main_link = 'https://erp.kidzonia.co.in/panel/admin';
					var dayplan_link = 'https://erp.kidzonia.co.in/panel/dayplan';
					this.setState({
						main_link: main_link,
						dayplan_link: dayplan_link,
						aToken:aToken
					});
				}
				else{
					var aToken='null';
					localStorage.setItem("aToken",aToken);
					var main_link = 'https://erp.kidzonia.co.in/panel/admin';
					var dayplan_link = 'https://erp.kidzonia.co.in/panel/dayplan';
					this.setState({
						main_link: main_link,
						dayplan_link: dayplan_link,
						aToken:aToken
					});
				}
			}
		});
		
		setTimeout(() => {
			this.checkData();
		}, 100);
	}
	
	handleSubmit(e){
		setTimeout(() => {
			this.checkData();
		}, 50);
	} 
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			this.setState({ user_id : storedArray['data'][0]['user_id'] });
			var user_id = this.props.match.params.id;
			var school_id = storedArray['data'][0]['school_id'];
			var app = {user_id : user_id,school_id:school_id}
			getData('GraphApi/children_fees',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							child_data: result['data'],
							graph_data: result['data'][0]['graph_data'],
						});
					}else{
						this.setState({
							child_data: [],
							graph_data: [],
						});
					}
				}
			});
		}
    }
	
	
	
	handleSizeChange = e => {
		this.setState({ [e.target.name]: e.target.value });
	};
	
	
  

	render()

	{
	const {aToken}=this.state;
	const options = {
	  scales: {
		y: {
		  beginAtZero: true,
		  ticks: {
			callback: function (value) {
			  return value + '%';
			},
		  },
		},
		 yAxes: [{
		  scaleLabel: {
			display: true,
			labelString: 'In Percentage',
		  }
		}],
		xAxes: [{
		  scaleLabel: {
			display: true,
			labelString: 'Month'
		  }
		}],

	  },
	};
					
		return (
			<>
			
				<div class="row bred">
					<div class="col-md-12">
						<div class="card ">
							<div class="card-body ">
								<h4 class="page-title"> 
									<i class="mdi mdi-apple-keyboard-command title_icon"></i> Student Fees Report
									<div class="breadcrumb-wrapper">
										<ol class="breadcrumb">
											<li class="breadcrumb-item">
												<a href={`${process.env.PUBLIC_URL}/`} class="router-link-active" target="_self">
												<img src="https://erp.kidzonia.co.in/panel/assets/icons/home.png" className="home-img"/>
												</a>
											</li>
											<li class="breadcrumb-item"> Student Fees Report</li>
										</ol>
									</div>
								</h4>
							</div>
						</div>
					</div>
				</div>
				
				<div class="row">
					<div class="col-md-12 ">
					<div class="card mb-2">
					<div class="card-body student-fees-border">
						
						<div class="row ">
							{this.state.child_data.map((list,index) => (
							<>
							<div class="col-md-4">
								<p class="mb-1"><b>Student Name :</b> {list.name}</p>
							</div>
							<div class="col-md-4">
								<p class="mb-1" ><b>Academic Year :</b> {list.academic_year}</p>
							</div>
							<div class="col-md-4">
								<p class="mb-1"><b>Class :</b> {list.division}</p>
							</div>
							<div class="col-md-4">
								<p class="mb-1"><b>Parent :</b> {list.parent_name}</p>
							</div>
							<div class="col-md-4">
								<p class="mb-1"><b>Admission No :</b> {list.admission_no}</p>
							</div>
							<div class="col-md-4">
								<p class="mb-1"><b>DOB :</b> {list.birthday}</p>
							</div>
							<div class="col-md-4">
								<p class="mb-1"><b>Branch :</b> {list.school_name}</p>
							</div>
							</>
							))}
						
						</div>
						
					</div>
					</div>
					</div>
				</div>
				
				
                <div class="">
                  <div class="row">
                     <div class="col-lg-12 mb-3 graph-d">
						<div class="row">
						<div class="col-md-3">
						<div class="student-fees-border">
							<div class="col-md-12">
								<span class="title">Assign Fees</span>
							</div>
							{this.state.child_data.map((list,index) => (
							<>
							{list.fees_data.map((fee) => (
							<div class="col-md-12">
								<div class={`student-fees-card ${fee.class}`}>
									<h4 >{fee.name} <span>{fee.amount}</span></h4>
								</div>
							</div>
							))}
							<div class="col-md-12">
								<div class={`student-fees-card `}>
									<h4 >Total <span>{list.total_fees}</span></h4>
								</div>
							</div>
							<div class="col-md-12 mb-10 center">
								<div class="row">
									<div class="col-md-6">
										<span class="color-paid"></span>Paid
									</div>
									<div class="col-md-6">
									    <span class="color-uppaid"></span>Unpaid
									</div>
								</div>
							</div>
							</>
							))}
							
						</div>
						</div>
						<div class="col-md-3">
							<div class="student-fees-border">
								<div class="col-md-12">
									<span class="title">Outstanding Report</span>
								</div>
								<div class="col-md-12">
									{this.state.child_data.map((list,index) => (
									<>
									<p class="outstanding">Total  <span>{list.total_fees}</span></p>
									<p class="outstanding">Paid  <span>{list.total_paid}</span></p>
									<p class="outstanding">Paid % <span>{list.fees_paid}%</span></p>
									<p class="outstanding color-red">Unpaid <span>{list.total_pending}</span></p>
									<p class="outstanding">Payment Mode <span>{list.paid_by}</span></p>
									<p class="outstanding">Last Payment Date <span>{list.added_date}</span></p>
									</>
									))}
								</div>
							</div>
						</div>
						<div class="col-md-6">
							<div class="student-fees-border">
								<div class="col-md-12">
									<span class="title">Graph</span>
								</div>
								<Line data={this.state.graph_data} options={options} height={220} />
							</div>
							
						</div>
						
						</div>
                     </div>
                  </div>
               </div>
			   </>
		) 
	} 
}
export default Index;
